import createDefaultConfig from './default'
import { initialState } from './initialState'

const defaultConfig = createDefaultConfig(initialState)

export default defaultConfig
